import { Container, DateText, Input } from './styles';
import { Flex } from 'shared/ui/flex';
import { FC } from 'react';
import { DatePickerInputProps } from 'shared/types';
import { CalendarDatePicker } from '../calendarDatePicker';
import { ArrowLeftIconButton } from 'shared/ui/buttons/iconButtons/arrowLeftIconButton';
import { ArrowRightIconButton } from 'shared/ui/buttons/iconButtons/arrowRightIconButton';
import { formatWithLocale } from 'shared/lib/datepicker/helpers/dateHelper';
import { capitalizeFirstLetter } from 'shared/lib/string';
import 'react-day-picker/dist/style.css';

export const DatePickerInput: FC<DatePickerInputProps> = ({
	selected,
	isOpenCalendar,
	onSelect,
	onMonthChange,
	leftControlClick,
	rightControlClick,
	dateTextClick,
	id,
  isScreenSm
}) => {
	return (
		<Container id={id}>
			<Container>
				<Input $width={isScreenSm ? "100%" : '121px'} $height="50px" $borderRadius="50px" id="app-selected-date-value" data-value={formatWithLocale(selected, 'yyyy-MM-dd')} />
				<Flex
					$alignItems="center"
					$justify="space-between"
					$position="absolute"
					$top="1px"
					$width={isScreenSm ? "174px" : 'auto'}
					$height="50px"
				>
					<ArrowLeftIconButton onClick={leftControlClick} />
					<Flex
						className="date-picker"
						$direction="column"
						role="date-text"
						$alignItems="center"
						$height="35px"
						$margin="0 0 13px 0"
						$cursor="pointer"
						onClick={!window.matchMedia("(pointer: coarse)").matches ? dateTextClick : undefined}
						onTouchStart={dateTextClick}
					>
						<DateText>
							{capitalizeFirstLetter(
								formatWithLocale(selected, `eeeeee`),
							)}
						</DateText>
						<DateText>
							{isScreenSm ? formatWithLocale(selected, `dd MMMM`) : formatWithLocale(selected, `dd.MM`)}
						</DateText>
					</Flex>
					<ArrowRightIconButton onClick={rightControlClick} />
				</Flex>
			</Container>
			<Container $left="-16px">
				<CalendarDatePicker
					mode="single"
					selected={selected}
					onSelect={onSelect}
					onMonthChange={onMonthChange}
					isOpenCalendar={isOpenCalendar}
				/>
			</Container>
		</Container>
	);
};
